// ===== Interfaces =====

import type {
    IBuildStoreItemsByProductParams,
    IStoreItem,
} from '../interfaces';

/**
 * Builds a product-keyed store map without letting duplicate active Stripe
 * prices blank purchase UI. Cart-specific negotiation prices always win;
 * unrequested duplicates preserve the first Stripe item returned.
 */
const buildStoreItemsByProduct = ({
    itemsByPrice,
    negotiationRequestPriceIds = [],
}: IBuildStoreItemsByProductParams): Map<string, IStoreItem> => {
    const negotiationRequestPriceIdSet = new Set(negotiationRequestPriceIds);
    const itemsByProduct: Map<string, IStoreItem> = new Map();

    itemsByPrice.forEach((item: IStoreItem) => {
        const currentItem = itemsByProduct.get(item.productId);

        if (!currentItem) {
            itemsByProduct.set(item.productId, item);
            return;
        }

        const itemIsRequestedNegotiation = negotiationRequestPriceIdSet.has(item.priceId);
        const currentItemIsRequestedNegotiation = negotiationRequestPriceIdSet.has(
            currentItem.priceId,
        );

        if (itemIsRequestedNegotiation && !currentItemIsRequestedNegotiation) {
            itemsByProduct.set(item.productId, item);
        }
    });

    return itemsByProduct;
};

export default buildStoreItemsByProduct;
